var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSepa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    rx: 2,
    fill: "#F4F4F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8625 18.4484C22.378 18.4508 22.7933 18.8881 22.7902 19.4251L22.7606 25.5078C22.7575 26.0447 22.3371 26.478 21.8217 26.4755C21.3062 26.473 20.8909 26.0357 20.894 25.4988L20.9236 19.4161C20.9267 18.8791 21.3471 18.4459 21.8625 18.4484Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0207 18.4484C28.5362 18.4508 28.9515 18.8881 28.9484 19.4251L28.9188 25.5078C28.9157 26.0447 28.4953 26.478 27.9799 26.4755C27.4644 26.473 27.0491 26.0357 27.0522 25.4988L27.0818 19.4161C27.0849 18.8791 27.5053 18.4459 28.0207 18.4484Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1784 18.4484C34.6939 18.4508 35.1092 18.8881 35.1061 19.4251L35.0765 25.5078C35.0734 26.0447 34.6531 26.478 34.1376 26.4755C33.6221 26.473 33.2068 26.0357 33.2099 25.4988L33.2395 19.4161C33.2426 18.8791 33.663 18.4459 34.1784 18.4484Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4088 28.4321C19.586 28.2048 19.8522 28.0728 20.1333 28.0728H35.6754C35.9255 28.0728 36.1651 28.1773 36.3405 28.363L37.4328 29.5189C37.6967 29.7982 37.7738 30.2151 37.6285 30.5765C37.4832 30.9379 37.1438 31.1731 36.7676 31.1731H19.2322C18.8722 31.1731 18.5443 30.9575 18.3895 30.6189C18.2347 30.2803 18.2807 29.8792 18.5076 29.588L19.4088 28.4321Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.506 9.22816C27.8085 9.03137 28.1922 9.03137 28.4947 9.22816L37.4509 15.0543C37.8041 15.2841 37.9684 15.7298 37.8537 16.1468C37.739 16.5638 37.3729 16.8512 36.9565 16.8512H19.0443C18.6278 16.8512 18.2618 16.5638 18.147 16.1468C18.0323 15.7298 18.1967 15.2841 18.5499 15.0543L27.506 9.22816Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9728 12.1411L37.4509 15.0542C37.8041 15.284 37.9684 15.7297 37.8537 16.1467C37.739 16.5637 37.3729 16.851 36.9565 16.851H19.0443C18.6278 16.851 18.2618 16.5637 18.147 16.1467C18.0323 15.7297 18.1967 15.284 18.5499 15.0542L32.9728 12.1411Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4,
    height: 23.3333,
    fill: "white",
    transform: "translate(16.8 8.3335)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepa);
export default __webpack_public_path__ + "static/media/sepa.96367c666ce54696b9bb63d64339c094.svg";
export { ForwardRef as ReactComponent };